import { Modal } from "@mui/material";

export default function OkayModal({
  title,
  openModal,
  handleOkay
}) {
  return (
    <Modal
      open={openModal}
      aria-labelledby="exit-without-saving-title"
      aria-describedby="exit-without-saving-description"
    >
      <div className="dlt_wrapper" style={{ position: "fixed" }}>
        <div className="dbl_place_on_page">
          <div
            className="dlt_surround"
            style={{
              maxWidth: "clamp(200px, 80vw, 500px)",
              width: "max-content",
              paddingTop: "30px",
              paddingBottom: "30px",
              position: "relative",
            }}
          >
            <div className="dlt_title" style={{lineHeight: 1.2}}>{title || "Do you want to exit without saving?"}</div>
            {/* <div className="dlt_description">
                  <p> Are you sure you want to save this program as unassigned?</p>
                </div> */}
            <div className="dlt_exit_btm new_prog_modal_btn_container">
              <div
                className="dlt_exit_btn dlt_eb_scnd new_prog_modal_btl_style"
                style={{ background: "#166273" }}
                onClick={handleOkay}
              >
                Okay
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
